import styled from 'styled-components'
import { Tag } from 'antd'

export const StyledTag = styled(Tag)`
  .ant-tag-close-icon {
    margin-top: 6px;
  }
`
